module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADMSURBVEhL3ZU9DsIwDEadDkhcgoWjcJEyoIqBchbKABESLWMOwSmYOQATGwNDjS0yotR2QQLeYiuRvqf8tfD/hBCGsTWRxfoS7w+jy/V2qnxTxCE1ScE9wwk6GCPgxipJChazvHYIS2qp2CQu1iTVti5pJStqqbh5WeT+OdONSMBYJWIBY5GoBIxWohYwGolJwEglyWv6Dr5viz56yNpwRiywhDMigTWc6RT0CWeSgvWumbYt7qk1hTPJdzBo3ZG+02druIi+v8xfB+ABRj9+7E4RDdwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/acadmy/right-enter.png
// module id = DqnO
// module chunks = 4